/******************************************************************************
*
* ** CUSTOM JAVASCRIPT **
*
*
* -- CONTENTS --
*
*
* - Pre: Set active nav & footer links
*
* - 1: Add Codekit Bower dependencies
*
*   --** DOM READY **--
*
* - 2: Init & config dependencies
* -- 2.1: Add Retina class
* -- 2.2: Remove homepage preloader
* -- 2.3: Scrollreveal (config)
* -- 2.4: Owl Carousel (config & run)
* -- 2.5: matchHeight (config)
* -- 2.6: Select2 (config & run)
*
*
* - 3 & 4: Custom JS
* -- 3.1: Control nav on page scroll
* -- 3.2: Header parallax (config)
* -- 3.3: Conditionally run scrollReveal, fadeInScroll, MatchHeight and headerParallax
* -- 3.4: Force iframe aspect ratio 16:9
* -- 3.5: Success stories card BG
* -- 3.6: Animate cards on page scroll
* -- 3.7: Article fade in on scroll
* -- 3.8: Hamburger menu
* -- 3.9: Allow nav scroll in mobile portrait
* -- 4.0: Get single location slider img and reflect in thumbnail
* -- 4.1: Change sidebar CTA on single location page
* -- 4.2: Homepage mobile department accordion
*
*
******************************************************************************/


/*****************************************
    -- Pre: Set active nav & footer links
******************************************

/*************************************
//Please remove this for WordPress
************************************/

(function($){
    $(function () {

        var panorama;

        function gMap(element, latitude, longitude, headingSetting, pitchSetting) {
            panorama = new google.maps.StreetViewPanorama(
                document.getElementById(element),
                {
                position: {lat: latitude, lng: longitude},
                pov: {heading: headingSetting, pitch: pitchSetting},
                streetViewControl: true,
                streetViewControlOptions: {
                        position: google.maps.ControlPosition.LEFT_TOP
                    },
                zoom: 0
                });
        }

        var url = window.location;

        // Will only work if string in href matches with location
        $('ul.nav a[href="'+ url +'"]').parent().addClass('active');
        $('ul.footer-nav a[href="'+ url +'"]').addClass('active');

        // Will also work for relative and absolute hrefs
        //nav
        $('ul.nav a').filter(function() {
            return this.href == url;
        }).parent().addClass('active');
        //footer
        $('ul.footer-nav a').filter(function() {
            return this.href == url;
        }).find('li').addClass('active');
        //sidebar
        $('ul.sidebar-ul a').filter(function() {
            return this.href == url;
        }).find('li').addClass('active');



        /********************************************
            - 1. Add Codekit Bower dependencies
        ********************************************/

        //Add Bower dependencies to be concat & minified
        // @codekit-prepend '../bower_components/bootstrap-sass/assets/javascripts/bootstrap.js'
        // @codekit-prepend '../bower_components/matchHeight/dist/jquery.matchHeight.js'
        // @codekit-prepend '../bower_components/select2/dist/js/select2.js'
        // @codekit-prepend '../bower_components/scrollreveal/dist/scrollreveal.js'
        // @codekit-prepend '../bower_components/owl.carousel/dist/owl.carousel.js'
        // @codekit-prepend '../bower_components/owl.carousel2.thumbs/dist/owl.carousel2.thumbs.js'
        // @codekit-prepend 'google.js'

        //Please note, Owl Carousel JS included from Bower, Owl Carousel SCSS imported separately


        //$(document).ready(function() {

            $('.js-search-field').on('keypress', function(e) { 
                if ( e.which == 13 ) {
                    $('.btn-search').trigger('click');
                }
            });

            if ( $('.more-success-stories .col-sm-4').length === 2 ) {
                $('.more-success-stories .col-sm-4:first').addClass('col-sm-offset-2');
            }


            /********************************************
                -- 2.1: Add Retina class
            ********************************************/

            var $body = $('body');

            //Check for retina displays
            var retina = (window.retina || window.devicePixelRatio > 1);
            if (retina) {
                $body.addClass('retina');
            }



            /********************************************
                - 2. Init & config dependencies
            ********************************************/



            /********************************************
                -- 2.2: Remove preloader
            ********************************************/
            $('#preloader').fadeOut(250);



            /********************************************
                -- 2.3: Scrollreveal (config)
            ********************************************/

            //Create scrollreveal function, to be called in window.width() check
            /* function srConfig(className) {
                sr.reveal(className, {
                    duration : 700,
                    distance : '50px',
                    viewFactor : 0.1,
                    scale : 0.8,
                    useDelay : 'always'
                }, 75);
            }


            function runScrollreveal() {
                window.sr = ScrollReveal();
                if($body.hasClass('template-homepage')) {
                    srConfig('.location-card');
                    srConfig('.success-card-outer');
                    srConfig('.blog-card-outer');
                } else if($body.hasClass('blog-template')) {
                    srConfig('.blog-card-outer');
                } else if($body.hasClass('success-template')) {
                    srConfig('.success-module-outer');
                }
                srConfig('.scrollRevealItem');
            } */


            /********************************************
                -- 2.4: Owl Carousel (config & run)
            ********************************************/

            /*
            function owlCarouselRun(className, numItems) {
                $(className).owlCarousel({
                    margin:10,
                    responsiveClass:true,
                    lazyLoad:true,
                    nav:true,
                    dots:true,
                    responsive:{
                        0:{
                            items:1
                        },
                        768:{
                            items:2
                        },
                        992:{
                            items:3
                        },
                        1200:{
                            items:numItems,
                            nav:false,
                            dots:false,
                            mouseDrag:false
                        }
                    }
                });
            }

            owlCarouselRun('.blog-slider', 4);//homepage blog posts
            owlCarouselRun('.success-slider', 3);//homepage success stories posts
            */

            //Single location page carousel
            $('.location-carousel').owlCarousel({
                items: 1,
                thumbs: false,
                thumbsPrerendered: true,
                thumbContainerClass: 'owl-thumbs',
                thumbItemClass: 'owl-thumb-item',
                lazyLoad:true,
                loop:true,
                dots:true,
                margin:0,
                nav:true
            });


            $('.location-carousel .owl-next').html('<i class="icon-arrow-right"></i>');
            $('.location-carousel .owl-prev').html('<i class="icon-arrow-left"></i>');
            


            /********************************************
                -- 2.5: matchHeight (config)
            ********************************************/

            //call matchHeight methods, to be called in window.width() check
            function runMatchHeight() {
                $('.card-excerpt').matchHeight();
                $('.card-header').matchHeight();
                $('.blog-excerpt').matchHeight();
                $('h3.dept-heading').matchHeight();
                $('p.dept-description').matchHeight();
                $('.success-card-outer').matchHeight();
                $('article.job-single-post').matchHeight();
                $('.blog-card-outer').matchHeight();
            }
        
            if ( $body.hasClass('blog-template') ) {
                $('.blog-card-outer').matchHeight();
            }else if( $body.hasClass('success-template') ){
                $('.success-card-outer').matchHeight();
            }else {
                runMatchHeight();
            }



            /********************************************
                -- 2.6: Select2 (config & run)
            ********************************************/

            var $selectSearch  = $('.select2-search__field'),
                $nav           = $('nav.top-nav');

            function initSelect2(className, quote) {
                $(className).select2({
                    placeholder : quote,
                    allowClear : true,
                    maximumSelectionLength : 3,
                    //tags : true,
                    tokenSeparators : [','],
                    "language": {
                        "noResults": function(){
                            return "No matching keywords. Please try a different keyword.";
                        }
                    },
                    escapeMarkup: function (markup) {
                        return markup;
                    }
                }).on('select2:open',function(){
                    $('.select2-dropdown--above').attr('id','fix');
                    $('#fix').removeClass('select2-dropdown--above');
                    $('#fix').addClass('select2-dropdown--below');
                });
            }

            initSelect2('.search-keyword', "Type a job keyword and make a selection...");
            initSelect2('.search-location', "Select location(s)");

            //On mobile, if dropdown activated, remove nav for more screen real-estate
            if($(window).width() < 768) {
                var $selectOuter = $('.select2-selection--multiple');
                $selectOuter.click(function() {
                    if($(this).attr('aria-expanded') == 'true' || $selectSearch.is(':focus')) {
                        $nav.removeClass('scroll-nav');
                    }
                });
            }


            /********************************************
                - 3. Custom JS
            ********************************************/


            /********************************************
                 -- 3.1: Control nav on page scroll
            ********************************************/

            //nav animation on scroll
            var mainLogo = $('img.nav-logo').attr('src'),
                logoBlue = $('img.nav-logo').data('blue');

            $(window).scroll(function() {
                var scrollTop     = $(window).scrollTop(),
                    headerHeight  = $('header').height(),
                    $navLogo      = $('img.nav-logo');

                if(scrollTop < 10) {
                    $nav.removeClass('intermediate-nav scroll-nav');
                } else if(scrollTop >= 10 && scrollTop < (headerHeight - 100)) {
                    $nav.addClass('intermediate-nav').removeClass('scroll-nav');
                // Change logo to white
                    $navLogo.attr( 'src', mainLogo );
                } else {
                    $nav.addClass('scroll-nav');
                // Change logo to blue
                    $navLogo.attr('src', logoBlue);
                }


                //mobile - remove navigation if select2 has focus
                if($(window).width() < 768) {
                    var $selectOuter  = $('.select2-selection--multiple'),
                        $selectSearch = $('.select2-search__field');

                    if($selectOuter.attr('aria-expanded') == 'true' || $selectSearch.is(':focus')) {
                        $nav.removeClass('scroll-nav');
                    }
                }

            });



            /********************************************
                -- 3.2: Header parallax (config)
            ********************************************/

            //header parallax scroll
            function headerParallax() {
                $(window).scroll(function() {
                    var scrollTop = $(window).scrollTop();
                    $('.header-bg').css({
                        'transform': 'translate3d(0,' + scrollTop * 0.3 + 'px, 0)'
                    });
                });
            }



            /***********************************************************************************
                - 3.3: Conditionally run scrollReveal, fadeInScroll, MatchHeight and parallax
            ***********************************************************************************/


            //Check screen size and call screen-size dependent functions
            var eventFired = 0;

            if ($(window).width() > 1200) {
                fadeInScroll();
                headerParallax();

                if($body.hasClass('scrollreveal')) {
                    //runScrollreveal();
                    runMatchHeight();
                }
            } else {
                eventFired = 1;
                $('.hideme').css('opacity', '1');
            }

            $(window).on('resize', function() {
                if (!eventFired) {
                    if ($(window).width() > 1200) {
                        fadeInScroll();
                        headerParallax();

                        if($body.hasClass('scrollreveal')) {
                            //runScrollreveal();
                            runMatchHeight();
                        }
                    } else {
                        $('.hideme').css('opacity', '1');
                    }
                }
            });

            initMatchHeight = 0;

            if($(window).width() > 768) {
                runMatchHeight();
            } else {
                initMatchHeight = 1;
            }

            $(window).on('resize', function() {
                    runMatchHeight();
                // if(!initMatchHeight) {
                //     if($(window).width() > 768) {
                //         console.log($(window).width());
                    // }
                // }
            });



            /********************************************
                -- 3.4: Force iframe aspect ratio 16:9
            ********************************************/

            //force iframe aspect ratio 16:9
            function videoAspect() {
                var $videoIframe = $('.video-iframe iframe');
                var vidWidth = $videoIframe.width();
                $videoIframe.attr('height', vidWidth*9/16);
                $videoIframe.attr('width', vidWidth);
            }

            if($body.hasClass('template-homepage')) {
                videoAspect();

                $(window).resize(function() {
                    videoAspect();
                });
            }



            /********************************************
                -- 3.5: Success stories card BG
            ********************************************/

            //Set Success Card BG Image to same src as success story featured image src
            // var successCard = $('.success-card-outer');

            // $(successCard).each(function() {
            //     var successCardHeader = $(this).find('.success-card-header'),
            //         successImgSrc     = $(this).find('img.success-img').attr('src');

            //     $(successCardHeader).css({
            //         'background' : 'url(' + successImgSrc + ') no-repeat center center',
            //         'background-size' : 'cover'
            //     });
            // });



            /********************************************
                -- 3.6: Animate cards on page scroll
            ********************************************/

            function fadeInScroll() {
                $('body.animate-scroll').find('article.job-single-post').addClass('hideme');
                $('body.animate-scroll').find('.dept-outer').addClass('hideme');
                $('body.animate-scroll').find('.blog-card-outer').addClass('hideme');

                $(window).scroll( function(){
                    $('.hideme').each( function(i){
                        var bottom_of_object = $(this).offset().top + ($(this).outerHeight() - 450);
                        var bottom_of_window = $(window).scrollTop() + $(window).height();

                        if( bottom_of_window > bottom_of_object ){
                            $(this).animate({'opacity':'1'}, 50)
                            .addClass("animated slideInUp");
                        }
                    });
                });
            }



            /********************************************
                -- 3.7: Article fade in on scroll
            ********************************************/

            //Set up fade in on scroll - https://jsfiddle.net/tcloninger/e5qaD/
            $(window).scroll( function(){
                $('.featured-tag').each( function(i){
                    var bottom_of_object = $(this).offset().top + ($(this).outerHeight() + 200);
                    var bottom_of_window = $(window).scrollTop() + $(window).height();

                    if( bottom_of_window > bottom_of_object ){
                        $(this).animate({'opacity':'1'}, 100)
                        .addClass("animated tada");
                    }
                });
            });



            /****************************************************
                -- 3.8: Hamburger menu
            ****************************************************/

            $('button.navbar-toggle').click(function(){
                if($('button.navbar-toggle').hasClass('collapsed')) {
                    $('.menu').addClass('open');
                } else {
                    $('.menu').removeClass('open');
                }
            });    

            // $(document).on('click', '.navbar-nav li.dropdown', function(event) {
            //     event.preventDefault();
            //     console.log($(this));
            //     $('#menu-header li').each(function(index, el) {
            //         $(el).removeClass('open');
            //     });
            //     $(this).addClass('open');
            // });



            /****************************************************
                -- 3.9: Allow nav scroll in mobile portrait
            ****************************************************/

            $( window ).resize(function() {
                $(".navbar-collapse").css({ maxHeight: $(window).height() - $(".navbar-header").height() + "px" });
            });



            /*********************************************************************
                -- 4.0: Get single location slider img and reflect in thumbnail
            *********************************************************************/

            //Set Success Card BG Image to same src as success story featured image src
            var locationImg = $('.location-img');
            var thumbImg = $('.location-thumb');

            $(locationImg).each(function() {
                var carouselImgSrc = $(this).css('background').split(",");
                    carouselImgSrc = carouselImgSrc[3];
                    carouselImgSrc = carouselImgSrc.split(" ");
                    carouselImgSrc = carouselImgSrc[2];

                    for(var i = 0; i < thumbImg.length; i++) {
                        $(thumbImg).css({
                            'background' : carouselImgSrc + 'no-repeat center center',
                            'background-size' : 'cover'
                        });
                    }
            });



            /*************************************************************
                -- 4.1: Change sidebar CTA on single location page
            *************************************************************/

            /*************************************
            //Please remove this for WordPress
            ************************************/

            //Change sidebar CTA's
            var $locationCta = $('.sidebar-button');

            if($body.hasClass('template-london')) {
                $locationCta.text('View London jobs');
            } else if($body.hasClass('template-manchester')) {
                $locationCta.text('View Manchester jobs');
            } else if($body.hasClass('template-netherlands')) {
                $locationCta.text('View Netherlands jobs');
            } else if($body.hasClass('template-paris')) {
                $locationCta.text('View Paris jobs');
            } else if($body.hasClass('template-singapore')) {
                $locationCta.text('View Singapore jobs');
            } else if($body.hasClass('template-zug')) {
                $locationCta.text('View Zug jobs');
            } else if($body.hasClass('template-houston')) {
                $locationCta.text('View Houston jobs');
            }

            if($body.hasClass('locations-home')) {
                $('section.single-cta').remove();
            }



            /****************************************************
                -- 4.2: Single job post mobile CTA
            ****************************************************/

            if($body.hasClass('single-job')) {
                $(window).scroll(function() {
                    if($(window).width() < 1200) {
                        var scrollTop = $(window).scrollTop(),
                            windowHeight = $(window).height(),
                            elementPos = $('.main-cta').offset().top,
                            elementTop = elementPos - (windowHeight + 100);


                        if(scrollTop > 100 && scrollTop < elementTop) {
                            $('#apply-nav-outer').addClass('active');
                        } else {
                            $('#apply-nav-outer').removeClass('active');
                        }
                    }
                });
            }



            /****************************************************
                -- 4.3: Homepage mobile department accordion
            ****************************************************/

            $('a.btn-accordion').click(function() {
                $('.accordion').slideToggle();
                $(this).toggleClass('accordion-active');

                if($('.depts-accordion').hasClass('accordion-active')) {
                    $('.depts-accordion').text('Hide all -');
                } else {
                    $('.depts-accordion').text('Show all +');
                }
            });


            $(document).on('click', '.js-open-share-modal', function(event) {
                event.preventDefault();
            $('#share_modal').modal();
            });



            /****************************************************
                -- 5.0: Change share icons.
            ****************************************************/
            $.fn.exists = function(){ return this.length > 0; }
            if ( $('.social-sharing').exists() ) {
                $('.button-facebook').addClass('icon-social-facebook custom-sharing').removeClass('button-facebook');
                $('.button-twitter').addClass('icon-social-twitter custom-sharing').removeClass('button-twitter');
                $('.button-googleplus').addClass('icon-social-google custom-sharing').removeClass('button-googleplus');
                $('.button-linkedin').addClass('icon-social-linkedin custom-sharing').removeClass('button-linkedin');
                
            }


            setTimeout(runMatchHeight(), 1000);

        //});//End DOM Ready
    });


})(jQuery);